import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const CowhideVest = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.CowhideVest.itemName}
      name={SS23.tops.CowhideVest.itemName}
      price={SS23.tops.CowhideVest.itemPrice}
      fabric={SS23.tops.CowhideVest.itemFabric}
      src={SS23.tops.CowhideVest.sizeChart}
      divId={SS23.tops.CowhideVest.shopifyDivId}
      mainId={SS23.tops.CowhideVest.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.CowhideVest.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.CowhideVest.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default CowhideVest;
